import { useAuth } from "../hooks/useAuth";
import { Button } from "./Button";

export function LogoutButton() {
  const { logout } = useAuth();

  return (
    <Button variant="link" className="mt-auto self-center pt-6" onClick={logout}>
      Sign Out
    </Button>
  );
}
